export default __webpack_public_path__ + "images/next-white.svg";